// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register {
  height: 100vh;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.register::-webkit-scrollbar {
  width: 16px;
}
.register::-webkit-scrollbar-thumb {
  background-color: #CCD5FF;
  border-radius: 10px;
  border: 3px solid #f0f0f0;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
}
.register::-webkit-scrollbar-track {
  background-color: #f0f0f0;
  border-radius: 10px;
}
.register .card {
  width: 50%;
  max-height: 80vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  background-color: var(--body_background);
  border-radius: 10px;
}
.register .card .left {
  flex: 1 1;
  background: linear-gradient(rgba(39, 11, 96, 0.5), #CCD5FF), url("https://images.pexels.com/photos/9830108/pexels-photo-9830108.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1") center;
  background-size: cover;
  padding: 50px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  color: white;
}
.register .card .left h1 {
  font-size: 70px;
  line-height: 0px;
}
.register .card .left button {
  width: 50%;
  padding: 10px;
  border: none;
  background-color: white;
  color: #7CC6FE;
  font-weight: bold;
  cursor: pointer;
}
.register .card .right {
  flex: 1 1;
  padding: 50px;
  display: flex;
  flex-direction: column;
  gap: 50px;
  justify-content: center;
}
.register .card .right h1 {
  color: var(--body_color);
}
.register .card .right form {
  display: flex;
  flex-direction: column;
  gap: 30px;
  color: var(--body_color);
}
.register .card .right form input {
  border: none;
  border-bottom: 1px solid lightgray;
  padding: 20px 10px;
}
.register .card .right form .error {
  color: red;
}
.register .card .right form button {
  width: 50%;
  padding: 10px;
  border: none;
  background-color: #7CC6FE;
  color: var(--body_color);
  font-weight: bold;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/Register/Register.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,WAAA;AACJ;AAEE;EACE,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,4CAAA;AAAJ;AAGE;EACE,yBAAA;EACA,mBAAA;AADJ;AAIE;EACE,UAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,wCAAA;EACA,mBAAA;AAFJ;AAII;EACE,SAAA;EACA,0LAAA;EAEA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAHN;AAKM;EACE,eAAA;EACA,gBAAA;AAHR;AAMM;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAJR;AAQI;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AANN;AAQM;EACE,wBAAA;AANR;AASM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,wBAAA;AAPR;AASQ;EACE,YAAA;EACA,kCAAA;EACA,kBAAA;AAPV;AAUQ;EACE,UAAA;AARV;AAWQ;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,wBAAA;EACA,iBAAA;EACA,eAAA;AATV","sourcesContent":[".register {\n  height: 100vh;\n  background-color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &::-webkit-scrollbar {\n    width: 16px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #CCD5FF;\n    border-radius: 10px;\n    border: 3px solid #f0f0f0;\n    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: #f0f0f0;\n    border-radius: 10px;\n  }\n\n  .card {\n    width: 50%;\n    max-height: 80vh;\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    background-color: var(--body_background);\n    border-radius: 10px;\n\n    .left {\n      flex: 1;\n      background: linear-gradient(rgba(39, 11, 96, 0.5), #CCD5FF),\n        url(\"https://images.pexels.com/photos/9830108/pexels-photo-9830108.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1\") center;\n      background-size: cover;\n      padding: 50px;\n      display: flex;\n      flex-direction: column;\n      gap: 30px;\n      color: white;\n\n      h1 {\n        font-size: 70px;\n        line-height: 0px;\n      }\n\n      button {\n        width: 50%;\n        padding: 10px;\n        border: none;\n        background-color: white;\n        color: #7CC6FE;\n        font-weight: bold;\n        cursor: pointer;\n      }\n    }\n\n    .right {\n      flex: 1;\n      padding: 50px;\n      display: flex;\n      flex-direction: column;\n      gap: 50px;\n      justify-content: center;\n\n      h1 {\n        color: var(--body_color);\n      }\n\n      form {\n        display: flex;\n        flex-direction: column;\n        gap: 30px;\n        color: var(--body_color);\n\n        input {\n          border: none;\n          border-bottom: 1px solid lightgray;\n          padding: 20px 10px;\n        }\n\n        .error {\n          color: red;\n        }\n\n        button {\n          width: 50%;\n          padding: 10px;\n          border: none;\n          background-color: #7CC6FE;\n          color: var(--body_color);\n          font-weight: bold;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
